import React from 'react';
import Marker from './ElementsMarker/Marker';
export default function ElementsMarker(_a) {
    var targets = _a.targets, activeIndex = _a.activeIndex;
    return targets && targets.map(function (t) { return React.createElement(Marker, { target: t, active: activeIndex === t.index }); });
}
